import OverviewEquipmentGroups from './OverviewEquipmentGroups'
import overviewEquipmentGroupsContainer from './overviewEquipmentGroupsContainer'

export default overviewEquipmentGroupsContainer(OverviewEquipmentGroups)
